<template>
  <div class="">
    <div class="bg_white mt12 pt16 pb16 boxs1" v-for="item in this.bc">
      <SectionTitle :title="'BC選択'" :width="'140'" />
      <div class="bc_wrap">
        <div class="number_wrap pl15 pr15">
          <h3 class="bc_number bdb rb">BC：{{ item.bcNumber }}</h3>
        </div>
        <div class="item_wrap pl15 pr15 bdb pt25 pb25" v-for="value in item.selectItem">
          <div class="item_contents">
            <div class="item_image">
              <img :src="value.item.image" :alt="value.item.productName" v-on:error="imageError" :data-noimage="value.item.noImage">
            </div>
            <p class="item_title ab c5a" v-html="value.item.title">{{ value.item.title }}</p>
          </div>
          <div class="contents_detail">
            <div v-if="count.count != 0" class="count_wrap" v-bind:class="{ bdb: count.year != 0 && count.month != 0 || count.count != 0 }" v-for="count in value.countItem">
              <p class="month rb c5a"><span v-if="count.month != 0">{{ count.month }}<span class="month_text">月</span></span></p>
              <p v-if="count.count != 0" class="count rb c5a"><span class="count_text ab">数量</span>{{ count.count }}</p>
            </div>
            <div v-if="value.selectChildFund" class="child_wrap c5a">
              <span class="child_text ab">こども基金：</span>
              <span class="child_add ab">{{ value.child ? '支援する': '支援しない' }}</span>
            </div>

            <div class="price_wrap c5a">
              <p class="price rb"><span class="yen">￥</span>{{ value.price.toLocaleString() }}</p>
              <p class="point rm"><span class="point_text ab">ポイント：</span>{{ value.point.toLocaleString() }}<span class="pt ab">pt</span></p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="edit" class="edit_wrap confirm_coupon pr25">
        <router-link :to="{ name: 'SelectProducts' }" class="edit btn_yellow btn_mini" v-on:click.native="editBCItem(item.bcNumber)">編集</router-link>
      </div>
    </div>
  </div>

</template>

<script>
import SectionTitle from '@/components/common/SectionTitle';
import { mapGetters } from 'vuex';

export default {
  props: ['edit'],
  components: {
    SectionTitle
  },
  data() {
    return {
      bc: [],
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    bcItemList() {
      this.bc.splice(0, this.bc.lenght);
      // 合計金額、ポイント初期化
      this.$store.commit('setPurchaseTotalPrice', 0);
      this.$store.commit('setPurchaseTotalPoint', 0);
      let allBCs = JSON.parse(localStorage.getItem('selectBC'))
      let bcItems = null;
      if (allBCs) {
        for (var i = 0; i < allBCs.length; i++) {
          let bcItem = {
            bcNumber: allBCs[i],
            selectItem: []
          };
          bcItems = JSON.parse(localStorage.getItem(allBCs[i]));
          if (bcItems && bcItems.length != 0) {
            for (var a = 0; a < bcItems.length; a++) {
              let items = {
                item: {
                  image: bcItems[a].item.image,
                  noImage: bcItems[a].item.noImage,
                  title: bcItems[a].item.title,
                },
                countItem: [
                  { month: bcItems[a].countItem[0].month, count: bcItems[a].countItem[0].count },
                  { month: bcItems[a].countItem[1].month, count: bcItems[a].countItem[1].count }
                ],
                selectChildFund: bcItems[a].selectChildFund,
                child: bcItems[a].child,
                itemPrice: bcItems[a].itemPrice,
                itemPoint: bcItems[a].itemPoint,
                price: bcItems[a].price,
                point: bcItems[a].point
              }
              bcItem.selectItem.push(items);

              // this.totalPrice = this.totalPrice + bcItems[a].price;
              // this.totalPoint = this.totalPoint + bcItems[a].point;
              this.$store.commit('setPurchaseTotalPrice', this.purchaseTotalPrice + bcItems[a].price);
              this.$store.commit('setPurchaseTotalPoint', this.purchaseTotalPoint + bcItems[a].point);
            }
            this.bc.push(bcItem);
          }
        }

      }
    },
  },
  computed: mapGetters(['purchaseTotalPrice', 'purchaseTotalPoint']),
  created() {
    this.bcItemList();
  }

}
</script>

<style lang="css" scoped>
.bc_wrap .bc_number {
  font-size: 20px;
  margin-top: 15px;
  padding-bottom: 5px;
}
.bc_wrap .item_wrap {
  -ms-align-items: flex-start;
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.bc_wrap .item_contents {
  width: 31%;
}

.bc_wrap .item_image {
  margin: auto;
  width: 90%;
}

.bc_wrap .item_title {
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
}

.bc_wrap .contents_detail {
  width: 57.4%;
}

.bc_wrap .count_wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.bc_wrap .month {
  font-size: 24px;
}

.bc_wrap .month_text {
  font-size: 16px;
  margin-left: 2px;
}

.bc_wrap .count {
  font-size: 26px;
}

.bc_wrap .count_text {
  font-size: 14px;
  margin-right: 19px;
}

.bc_wrap .child_wrap {
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 22px;
}

.bc_wrap .price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.bc_wrap .price {
  font-size: 26px;
}

.bc_wrap .yen {
  font-size: 20px;
}
.bc_wrap .point {
  font-size: 16px;
}
.bc_wrap .point_text {
  font-size: 12px;
}
.bc_wrap .pt {
  font-size: 14px;
}
.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/ConfirmProductsList.vue